module.exports = __webpack_public_path__ + "static/transports-in-japan-suica-e9afeeca38adbc016deaadc84f960b82.jpg";